import { Component, OnInit } from '@angular/core';
import { Role, Users } from 'src/app/models/um/organization';
import { UserService } from 'src/app/services/user.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';

@Component({
  selector: 'app-view-profile',
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.scss']
})
export class ViewProfileComponent implements OnInit {
  isChecked: number;
  userDet: Users;
  Userdetails: Users
  orgCode: string;
  userType: string;
  role: String;
  emailID: String;
  timeZoneForm: UntypedFormGroup;
  title: String;
  userSelctedTimeZone: string;
  TimeZoneList: any;
  model: Users 
  constructor(public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private userService: UserService,
    private commonservice: CommonService
  ) { }


  ngOnInit() {
    this.getTimeZones();
    this.getUserDetails();
    this.userService.GetUsersRoles(this.userDet?.ID).subscribe(summary => {
      this.userSelctedTimeZone = summary.userTimeZone;
    });
    this.getRoles();
  }
  changePwd(){
    this.close();
    let modalRef = this.modalService.open(ChangePasswordComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md pt-5',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Change Password',
      content: {old_password_field_req:true}
    }
  }
  close(){
    this.modalRef.dismiss();
  }

  getUserDetails(){
    this.userDet = this.userService.getUserDetais();
    this.orgCode = this.userDet?.ORGANIZATION_ID;
    this.userType = this.userDet?.USER_TYPE;


  }
  
  SelectTimezone(event) {
    const TimeZone = { value: this.userSelctedTimeZone, label:"" }
    this.userService.timeZoneAutoSave(TimeZone).subscribe(result => {
      if (result != null) {
        if (result.Status === 0) {
          this.userService.setLoggedUserTimeZone(this.userSelctedTimeZone);
          this.commonservice.SuccessBanner(result.Message);
        }        
      }
    })
  }
 

  getTimeZones() {
    this.userService.fetchTimeZones().subscribe(result => {
      this.TimeZoneList = result;
    }
    )
  }

    getRoles(): void {
    this.userService.GetUsersRoles(this.userDet?.ID).subscribe(summary => {
        this.role = summary.roles.map(x=>' ' + x.NAME +' ');
        this.title=summary.userProfileDetails.map(x=>' ' + x.TITLE +' ');
        this.emailID=summary.userProfileDetails.map(x=>' ' + x.EMAIL +' ');
    });
  }

}
